<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>냉장고 상세 정보 조회</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="goList">냉장고 리스트</button>
        </div>
        <div>
          <button class="btn btn-140" @click="deleteDevice">
            <span v-if="!processing" class="process">냉장고 삭제</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div>
          <button class="btn btn-140" @click="updateDevice">냉장고 수정</button>
        </div>
        <div>
          <button class="btn btn-140" @click="goTrayList">트레이 리스트</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div v-if="detailType === 'view'" class="table-content">
        <table>
          <tr>
            <td class="header">사업자 번호</td>
            <td>{{ device.registrationNo }}</td>
          </tr>
          <tr>
            <td class="header">냉장고 ID</td>
            <!-- TODO <td>{{ device.deviceAlias }}</td> -->
            <td>{{ device.deviceID }}</td>
          </tr>
          <tr>
            <td class="header">장소</td>
            <td>{{ device.place }}</td>
          </tr>
          <tr>
            <td class="header">설치 날짜</td>
            <td>{{ device.setupDate }} {{ device.setupTime }}</td>
          </tr>
          <tr>
            <td class="header">IP</td>
            <td>{{ device.ip }}</td>
          </tr>
          <tr>
            <td class="header">사업자 회사</td>
            <td>{{ device.companyName }}</td>
          </tr>
          <tr>
            <td class="header">사업자 담당자</td>
            <td>{{ device.operatorName }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">등록일</td>
            <td></td>
          </tr>
          <tr>
            <td class="header">냉장고 이름</td>
            <td>{{ device.deviceName }}</td>
          </tr>
          <tr>
            <td class="header">주소</td>
            <td>{{ device.address }}</td>
          </tr>
          <tr>
            <td class="header">제조 날짜</td>
            <td>{{ device.manufactureDate }} {{ device.manufactureTime }}</td>
          </tr>
          <tr>
            <td class="header">Port</td>
            <td>{{ device.port }}</td>
          </tr>
          <tr>
            <td class="header">운영자 회사</td>
            <td>{{ device.deviceCompanyName }}</td>
          </tr>
          <tr>
            <td class="header">운영자 담당자</td>
            <td>{{ device.deviceOperatorName }}</td>
          </tr>
        </table>
      </div>
      <div v-else-if="detailType === 'edit'" class="table-content">
        <table>
          <tr>
            <td class="header">사업자 번호</td>
            <td>{{ device.registrationNo }}</td>
          </tr>
          <tr>
            <td class="header">냉장고 ID</td>
            <!-- TODO <td><input type="input" v-model="editDevice.deviceAlias" tabindex="1"/></td> -->
            <td> {{ editDevice.deviceID }} </td>
          </tr>
          <tr>
            <td class="header">장소</td>
            <td><input type="input" v-model="editDevice.place" tabindex="3"/></td>
          </tr>
          <tr>
            <td class="header">설치 날짜</td>
            <td><input type="input" v-model="editDevice.setupAt" tabindex="5"/></td>
          </tr>
          <tr>
            <td class="header">IP</td>
            <td><input type="input" v-model="editDevice.ip" tabindex="7"/></td>
          </tr>
          <tr>
            <td class="header">사업자 회사</td>
            <!--
            <td>
              <select v-model="editDevice.companyID" @change="selectCompany(editDevice.companyID, 1)" tabindex="9">
                <option v-for="item in companyList" :key="item.companyID" :value="item.companyID">
                  {{ item.companyName }}
                </option>
              </select>
            </td>
            -->
            <td>{{ editDevice.companyName }}</td>
          </tr>
          <tr>
            <td class="header">사업자 부서</td>
            <td>
              <select v-model="editDevice.divisionID" @change="selectDivision(editDevice.divisionID, 1)" tabindex="11">
                <option v-for="item in divisionList"
                  :key="item.divisionID"
                  :value="item.divisionID">
                  {{ item.divisionName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">사업자 담당자</td>
            <td>
              <select v-model="editDevice.operatorUID" tabindex="13">
                <option v-for="item in userList" :key="item.uID" :value="item.uID">
                  {{ item.name }}
                </option>
              </select>
            </td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">등록일</td>
            <td></td>
          </tr>
          <tr>
            <td class="header">냉장고 이름</td>
            <td><input type="input" v-model="editDevice.deviceName" tabindex="2"/></td>
          </tr>
          <tr>
            <td class="header">주소</td>
            <td><input type="input" v-model="editDevice.address" tabindex="4"/></td>
          </tr>
          <tr>
            <td class="header">제조 날짜</td>
            <td><input type="input" v-model="editDevice.manufactureAt" tabindex="6"/></td>
          </tr>
          <tr>
            <td class="header">Port</td>
            <td><input type="input" v-model="editDevice.port" tabindex="8"/></td>
          </tr>
          <tr>
            <td class="header">운영자 회사</td>
            <td>
              <select v-model="editDevice.deviceCompanyID" @change="selectCompany(editDevice.deviceCompanyID, 2)" tabindex="10">
                <option v-for="item in operatorCompanyList" :key="item.companyID" :value="item.companyID">
                  {{ item.companyName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">운영자 부서</td>
            <td>
              <select v-model="editDevice.deviceDivisionID" @change="selectDivision(editDevice.deviceDivisionID, 2)" tabindex="12">
                <option v-for="item in operatorDivisionList"
                  :key="item.divisionID"
                  :value="item.divisionID">
                  {{ item.divisionName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">운영자 담당자</td>
            <td>
              <select v-model="editDevice.deviceOperatorUID" tabindex="14">
                <option v-for="item in operatorUserList" :key="item.uID" :value="item.uID">
                  {{ item.name }}
                </option>
              </select>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="detailType === 'edit'" class="table-btn center">
        <div>
          <button
            class="btn btn-140 btn-blue-line" @click="excuteUpdate">
            <span v-if="!processing" class="process">수정</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div>
          <button
            class="btn btn-right"
            @click="cancelUpdate"
          >취소</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'device',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    detailType: 'view',
    editDevice: {
      deviceID: null,
      deviceName: null,
      deviceAlias: null,
      address: null,
      place: null,
      manufactureAt: null,
      setupAt: null,
      ip: null,
      port: null,
      companyID: null,
      divisionID: null,
      operatorUID: null,
      registrationNo: null,
      deviceCompanyID: null,
      deviceDivisionID: null,
      deviceOperatorUID: null,
    },
    companyList: [],
    divisionList: [],
    userList: [],
    operatorCompanyList: [],
    operatorDivisionList: [],
    operatorUserList: [],
    operatorCompanyID: null,
    operatorDivisionID: null,
    processing: false,
  }),
  created() {
    this.fetchCompanyList(1);
    this.fetchCompanyList(2);
  },
  methods: {
    async updateDevice() {
      this.editDevice.deviceID = this.device.deviceID;
      this.editDevice.deviceAlias = this.device.deviceAlias;
      this.editDevice.deviceName = this.device.deviceName;
      this.editDevice.deviceAlias = this.device.deviceAlias;
      this.editDevice.address = this.device.address;
      this.editDevice.place = this.device.place;
      this.editDevice.manufactureAt = this.device.manufactureAt;
      this.editDevice.setupAt = this.device.setupAt;
      this.editDevice.ip = this.device.ip;
      this.editDevice.port = this.device.port;
      this.editDevice.companyID = this.device.companyID;
      this.editDevice.divisionID = this.device.divisionID;
      this.editDevice.operatorUID = this.device.operatorUID;
      this.editDevice.registrationNo = this.device.registrationNo;
      this.editDevice.deviceCompanyID = this.device.deviceCompanyID;
      this.editDevice.deviceDivisionID = this.device.deviceDivisionID;
      this.editDevice.deviceOperatorUID = this.device.deviceOperatorUID;
      this.editDevice.companyName = this.device.companyName;

      this.detailType = 'edit';
      await this.selectCompany(this.device.companyID, 1);
      await this.selectDivision(this.device.divisionID, 1);
      await this.selectCompany(this.device.deviceCompanyID, 2);
      await this.selectDivision(this.device.deviceDivisionID, 2);
    },
    async fetchCompanyList(type) {
      try {
        const listURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/list?page=1&limit=500`;

        const list = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          throw new Error(`Response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${list.data.resultCode}"`);
        }

        const companyList = [];
        for (let i = 0; i < list.data.companies.length; i++) {
          const p = list.data.companies[i];
          if (type === 1 && p.scope === 3 || type === 2 && p.scope === 4 && this.device.companyID === p.parentCompanyID) {
            companyList.push(p);
          }
        }
        if (type === 1) {
          this.companyList = companyList;
        } else {
          this.operatorCompanyList = companyList;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async selectCompany(companyID, type) {
      if (!companyID) {
        return;
      }
      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${companyID}?withDivisions=true`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });

        if (result.status !== 200) {
          throw new Error(`Response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${result.data.resultCode}"`);
        }

        if (type === 1) {
          this.userList = [];
          this.divisionList = result.data.company.divisions;
        } else {
          this.operatorUserList = [];
          this.operatorDivisionList = result.data.company.divisions;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async selectDivision(divisionID, type) {
      if (!divisionID) {
        return;
      }
      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/division/${divisionID}?withUsers=true`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (result.status !== 200) {
          throw new Error(`Response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${result.data.resultCode}"`);
        }

        if (type === 1) {
          this.userList = [];
          this.userList.push('');
          for (let i = 0; i < result.data.division.users.length; i++) {
            if (result.data.division.users[i].role === 2 || result.data.division.users[i].role === 3) {
              this.userList.push(result.data.division.users[i]);
            }
          }
        } else {
          this.operatorUserList = [];
          this.operatorUserList.push('');
          for (let i = 0; i < result.data.division.users.length; i++) {
            if (result.data.division.users[i].role === 2 || result.data.division.users[i].role === 3) {
              this.operatorUserList.push(result.data.division.users[i]);
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async excuteUpdate() {
      try {
        this.processing = true;
        const url = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${this.device.deviceID}`;


        const param = this.editDevice;
        param.manufactureAt = new Date(this.$moment(param.manufactureAt).format()).toISOString();
        param.setupAt = new Date(this.$moment(param.setupAt).format()).toISOString();
        const createResult = await this.$http.put(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        const company = {
          id: this.device.companyID,
          name: this.device.companyName,
          alias: this.device.companyAlias,
        };
        this.processing = false;
        this.$emit('refreshList', company, 'company', 1);
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
    cancelUpdate() {
      this.detailType = 'view';
    },
    async deleteDevice() {
      this.processing = true;
      const device = await this.$getDevice(this.device.deviceID, false, true);
      if (!device) {
        alert('존재하지 않는 냉장고입니다.');
        this.processing = false;
        return;
      } else if (device.dependence) {
        alert('사용중인 냉장고는 삭제할 수 없습니다.\n"냉장고 관리" 및 "재고 관리"를 확인해 주세요.');
        this.processing = false;
        return;
      }

      if (!confirm('정말 삭제하시겠습니까?')) {
        this.processing = false;
        return;
      }

      try {
        const url = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${this.device.deviceID}`;

        const createResult = await this.$http.delete(url,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        const company = {
          id: this.device.companyID,
          name: this.device.companyName,
          alias: this.device.companyAlias,
        };
        this.processing = false;
        this.$emit('refreshList', company, 'company', 1);
      } catch (e) {
        if (e.response.status === 403) {
          alert('사용중 입니다.');
        } else {
          console.error(e);
        }
        this.processing = false;
      }
    },
    goList() {
      const company = {
        id: this.device.companyID,
        name: this.device.companyName,
        alias: this.device.companyAlias,
      };
      this.$emit('refreshList', company, 'company');
    },
    goTrayList() {
      const device = {
        id: this.device.deviceID,
        name: this.device.name,
        alias: this.device.deviceAlias,
        pId: this.device.companyID,
        pName: this.device.companyName,
        pAlias: this.device.companyAlias,
      };
      this.$emit('refreshList', device, 'device');
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceDetail.vue